const shortDateFormatter = new Intl.DateTimeFormat('en-AU');
const longDateFormatter = new Intl.DateTimeFormat('en-AU', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});
const monthYearFormatter = new Intl.DateTimeFormat('en-AU', {
  month: 'long',
  year: 'numeric',
});

/**
 * Format a date-like value for compact user-facing displays.
 */
export function formatShortDate(
  value?: string | number | Date | null,
  fallback: string = 'Not set',
): string {
  if (!value) {
    return fallback;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return fallback;
  }

  return shortDateFormatter.format(date);
}

/**
 * Format a date-like value for longer profile or detail displays.
 */
export function formatLongDate(
  value?: string | number | Date | null,
  fallback: string = 'Not set',
): string {
  if (!value) {
    return fallback;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return fallback;
  }

  return longDateFormatter.format(date);
}

/**
 * Format a date-like value as month plus year.
 */
export function formatMonthYear(
  value?: string | number | Date | null,
  fallback: string = '',
): string {
  if (!value) {
    return fallback;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return fallback;
  }

  return monthYearFormatter.format(date);
}
